import SignDocumentsError from './SignDocumentsError';

export default SignDocumentsError;
